import { createContext, useContext } from "react";
import type { AppConfig } from "@/betby/infrastructure/config/appConfig";

export const AppConfigContext = createContext<AppConfig | null>(null);

export function useAppConfig(): AppConfig {
  const context = useContext(AppConfigContext);

  if (!context) {
    throw new Error(
      "[BetbyProvider] useAppConfig must be used within BetbyProvider",
    );
  }

  return context;
}
